import { faCheck, faChevronLeft, faSearch, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { useAddonContext } from '../../context/AddonFeatureContext'
import { skills } from '../../utilities/constants'
import useDebounce from '../../hooks/useDebounce'
import { filledstars, notFilledstars } from '../AnalysisPage/NewCourseDetailsModal'
import CoursesList from './CoursesList'

const features = [
    <span>Unlimited Access To <span className='text-span_color'>1,240+ Certified Courses</span></span>,
    'Evaluation Test With Live Feedback After Every Video Lesson',
    '24/7 Live Doubt Solving',
    'Life-Time Access Of Course Completion Certificates'
]

export const SkillsListToShow = ({ skills, ratings, students, doNotshowRating }) => {
    
    return <div className='flex flex-col gap-1.5'>
        {skills.map((item, index) => (
            <div key={index} className='bg-bg-13/[15%] flex items-center rounded-xl py-2.5 px-3'>
                <h3 className='flex-1 text-sm font-medium'>{item?.skill_name}</h3>
                {!doNotshowRating && <div className='flex flex-col gap-0.5 items-center mt-1'>
                    <div className='flex'>
                        {filledstars(ratings[index])}
                        {notFilledstars(ratings[index])}
                    </div>
                    <p className='text-xs text-white/50 mt-0.5'>{students[index]} Students</p>
                </div>}
            </div>
        ))}
    </div>
}

const ProMembershipSection = () => {

    const  [ searchParam, setSearchParam ] = useState('')
    const [ searchedResult, setSearchedResult ] = useState([])

    const { debouncedValue } = useDebounce(searchParam, 300)

    const { skillsToShow, showSkillList, ratings, setRatings, students, setStudents, courseNameInModal, imageLink, handleSkillSelection, setShowSkillList } = useAddonContext()

    useEffect(() => {
        if (debouncedValue){
            let result = []
            for (let item of skills) {
                let filteredArray = item.filter((arr) => arr?.skill_name?.toLowerCase()?.includes(debouncedValue.toLowerCase()))
                result = [...result, ...filteredArray]
            }
            setSearchedResult(result)
        }
    }, [debouncedValue])
    
    useEffect(() => {
        if(debouncedValue){
            setRatings(Array.from({ length: searchedResult?.length }, () => Math.random() < 0.5 ? 4.5 : 5))
            setStudents(Array.from({ length: searchedResult?.length }, () => Math.floor(Math.random() * (1500 - 1300 + 1)) + 1300))
        }
    }, [debouncedValue, searchedResult?.length, setRatings, setStudents])

    return (
        <div>
            <div>
                <h3 className='font-semibold mb-3'>Learning Features</h3>
                <div className='mt-3 rounded-xl bg-bg-13/[15%]'>
                    {features?.map((item, index) => (
                        <div className={`flex items-center gap-2 py-3 px-3 ${index !== 3 && 'border-b-[0.8px] border-[#395C7E]'}`}>
                            <div className='w-4 h-4 rounded-full bg-secondary-text flex items-center justify-center'>
                                <FontAwesomeIcon icon={faCheck} className='text-xs' />
                            </div>
                            <p className='text-sm font-medium flex-1'>{item}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className='mt-4'>
                <div>
                    <h3 className='font-semibold'>Explore All Courses</h3>
                    <p className='text-sm text-white/50 mt-0.5'>Syllabus can be viewed post purchase</p>
                </div>
                <div className='relative mt-3'>
                    <form>
                        <div className='absolute inset-y-0 left-0 pl-3 flex items-center'>
                            <FontAwesomeIcon icon={faSearch} className='text-lg text-white/50'/>
                        </div>
                        {searchParam && <div className='absolute inset-y-0 right-3 flex items-center' onClick={() => setSearchParam('')}>
                            <FontAwesomeIcon icon={faXmark} className='text-xl text-[#6D90B4]'/>
                        </div>}
                        <input 
                            type="text"
                            value={searchParam}
                            onChange={(e) => setSearchParam(e.target.value)}
                            tabIndex={-1}
                            placeholder='Search for any course'
                            className='w-full py-2.5 bg-bg-13/[15%] text-sm font-medium border-none rounded-lg placeholder:text-sm placeholder:font-medium placeholder:text-[#6D90B4] px-10 job-role'
                        />
                    </form>
                </div>
                <div className='mt-3'>
                    <h2 className='mb-3'>{searchParam ? 'Search Results' : showSkillList ? (<div className='flex items-center gap-1'>
                        <FontAwesomeIcon icon={faChevronLeft} className='text-2xl mr-2 mt-1' onClick={() => setShowSkillList(false)}/>
                        <img src={imageLink} alt='' className='inline mr-2'/>
                        {courseNameInModal}
                    </div>) : "Select Category"}</h2>
                </div>
                {!debouncedValue ? (!showSkillList ? <div className='flex flex-col gap-1'>
                    <CoursesList handleSkillSelection={handleSkillSelection} />
                </div> : <SkillsListToShow
                    skills={skillsToShow}
                    ratings={ratings}
                    students={students}
                    imageLink={imageLink}
                />) : (searchedResult?.length > 0 ? <SkillsListToShow
                    skills={searchedResult}
                    ratings={ratings}
                    students={students}/>
                : <p className='text-center text-white/50'>No Result</p>)}
            </div>
        </div>
    )
}

export default ProMembershipSection